import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Eye } from 'lucide-react';
const MIN_VIEWERS = 128;
const MAX_VIEWERS = 214;
export function LiveViewers() {
  const [viewers, setViewers] = useState(167);
  useEffect(() => {
    let timeoutId: number;
    const schedule = () => {
      timeoutId = window.setTimeout(() => {
        setViewers(current => {
          const delta = Math.floor(Math.random() * 7) - 3;
          const next = current + delta;
          if (next < MIN_VIEWERS) return MIN_VIEWERS + Math.abs(delta);
          if (next > MAX_VIEWERS) return MAX_VIEWERS - Math.abs(delta);
          return next;
        });
        schedule();
      }, 2600 + Math.random() * 2600);
    };
    schedule();
    return () => window.clearTimeout(timeoutId);
  }, []);
  return <motion.aside role="status" aria-live="polite" initial={{
    opacity: 0,
    y: -14,
    scale: 0.96
  }} animate={{
    opacity: 1,
    y: 0,
    scale: 1
  }} transition={{
    duration: 0.6,
    delay: 1.2,
    ease: [0.22, 1, 0.36, 1]
  }} className="fixed right-3 top-[86px] z-50 rounded-lg border border-gold/25 bg-[linear-gradient(180deg,rgba(18,18,22,0.96),rgba(10,10,13,0.96))] px-3 py-2 shadow-[0_14px_34px_rgba(0,0,0,0.6)] backdrop-blur-md sm:right-5 lg:top-[68px]" data-id="element-196" data-mp="281dtbrbbq9rl">
      <div className="flex items-center gap-2.5" data-id="element-197" data-mp="2exea8wct5k6f">
        <span className="relative flex h-2 w-2 flex-shrink-0" data-id="element-198" data-mp="2eyp9qjz805rq">
          <span aria-hidden="true" className="absolute inline-flex h-full w-full animate-ping rounded-full bg-signal-cyan opacity-70" data-id="element-199" data-mp="3cl4txtj17hiz" />
          <span aria-hidden="true" className="relative inline-flex h-2 w-2 rounded-full bg-signal-cyan shadow-[0_0_8px_#00e5ff]" data-id="element-200" data-mp="32mp0hjwj7w6b" />
        </span>

        <Eye aria-hidden="true" className="h-3.5 w-3.5 text-gold" data-id="element-201" data-mp="2yn6gcqcjbp4j" />

        <p className="text-[11px] leading-tight text-ash" data-id="element-202" data-mp="1r8bgwr8ta2w3">
          <motion.span key={viewers} initial={{
          opacity: 0.4,
          y: -4
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.25
        }} className="inline-block font-display text-[15px] font-extrabold text-bone" data-id="element-203" data-mp="1n66q009qzkd5">
            {viewers}
          </motion.span>{' '}
          <span className="hidden sm:inline" data-id="element-204" data-mp="1enwhj7y14v17">personas viendo</span>
          <span className="sm:hidden" data-id="element-205" data-mp="1jnr634uc18j3">viendo</span>
          <span className="block font-mono text-[8.5px] uppercase tracking-[0.14em] text-gold-dim" data-id="element-206" data-mp="1jmg49akg6aum">
            este expediente ahora
          </span>
        </p>
      </div>
    </motion.aside>;
}